import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useBlackListAdd = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ subject, description }: any) => {
      return api.blackList.add({
        subject,
        description,
        created: null,
        kind: 'TOTAL_CNT_BY_RECIPIENT_CARD',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blackList'] })

      toaster.create({
        type: 'success',
        title: 'Добавлен элемент в черный список',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при попытке добавить элемент',
        description: err.message,
      })
    },
  })
}
